import config from "config";
const hostname = window && window.location && window.location.hostname;
// export const tenantId = "7dcab1ae-f10a-40fa-be0b-8726adb623bd";
// export const clientId = "e2c9204c-dd8d-4fa4-8c10-5b4cdc50282d";
// const configId = "f9158b6e-f68e-4d42-89a0-da328c804b59";
// const osapiId = "527b2b3f-788f-4422-99ca-927726ca72c8";
// const messengerId = "2d3ab7dc-69b8-49d5-856c-f7a5f33fc24c";
export const tenantId = config.TENANT_ID;
export const clientId = config.CLIENT_ID;
const configId = config.CONFIG_ID;
const osapiId = config.OSAPI_ID;
const messengerId = config.MESSENGER_ID;
const osAnalyticsId = config.OS_ANALYTICS_ID;


const redirectUri =
  hostname === "localhost" ? "https://localhost:8118" : `https://${hostname}`;

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    // validateAuthority: true,
    // navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
  state: 1235,
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const osapiRequest = {
  scopes: [`api://${osapiId}/access_as_user`],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};

export const configRequest = {
  scopes: [`api://${configId}/access_as_user`],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};

export const messengerRequest = {
  scopes: [`api://${messengerId}/access_as_user`],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};

export const osAnalyticsRequest = {
  scopes: [`api://${osAnalyticsId}/access_as_user`],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};

